import { render, staticRenderFns } from "./AdminPosts.vue?vue&type=template&id=2cc36bcc"
import script from "./AdminPosts.vue?vue&type=script&lang=js"
export * from "./AdminPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports